import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router';
import Typography from '../../components/Typography';
import { TEXT_TRANSFORM, VARIANT_TYPOGRAPHY } from '../../enums';

import { Box, Menu, MenuItem, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SolutionMenu = ({ toggleClose, toggleOpen, toggle, isActive }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const options = [
    {
      id: 1,
      label: t('white-label'),
      path: '/white-label',
    },
    {
      id: 2,
      label: t('all-in-one-service'),
      path: '/self-service',
    },
    {
      id: 3,
      label: t('turnkey'),
      path: '/turnkey',
    },
  ];
  return (
    <Box>
      {/* <IconButton Icon={IconGlobe} onClick={toggleOpen} /> */}
      <Typography
        key={'01'}
        fontWeight={500}
        label={'Solutions'}
        variant={VARIANT_TYPOGRAPHY.H6}
        onClick={toggleOpen}
        // style={{ padding: '5px 20px' }}
        textTransform={TEXT_TRANSFORM.CAPITALIZE}
        color={theme.palette.text.secondary}
        sx={{
          // padding: '5px 20px',
          color: isActive ? '#9340BF' : '#FFFFFF', // Highlight active link
          fontFamily: 'Open Sans',
          fontWeight: '700 !important',
          position: 'relative',
          textTransform: 'none',
          fontSize: '16px',
          borderBottom: isActive ? '2px solid #5B3EDE' : '2px solid transparent',
          '&:hover': {
            borderBottom: '2px solid #5B3EDE',
            color: '#9340BF',
          },
        }}
      />
      <Menu
        id="basic-menu"
        anchorEl={toggle}
        open={Boolean(toggle)}
        onClose={toggleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: '200px !important',
            top: '65px !important',
            /*             left: '860px !important', */
            background: '#242424',
            color: '#000000',
          },
        }}
      >
        {options.map((item, index) => (
          <Box key={index}>
            <MenuItem
              onClick={() => navigate(item.path)}
              sx={{
                fontWeight: '700 !important',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: '#242424',
                },
              }}
            >
              <Typography
                key={'01'}
                fontWeight={500}
                label={item.label}
                variant={VARIANT_TYPOGRAPHY.H6}
                onClick={() => { }}
                // style={{ padding: '5px 20px' }}
                textTransform={TEXT_TRANSFORM.CAPITALIZE}
                color={theme.palette.text.secondary}
                sx={{
                  // padding: '5px 20px',
                  color: '#FFFFFF', // Highlight active link
                  fontFamily: 'Open Sans',
                  fontWeight: '700 !important',
                  position: 'relative',
                  textTransform: 'none',
                  fontSize: '16px',
                  borderBottom: '2px solid transparent',
                  width: '80px',
                  marginLeft: '12px',
                  '&:hover': {
                    borderBottom: '2px solid #5B3EDE',
                    color: '#9340BF',
                  },
                }}
              >
                {item.label}
              </Typography>
            </MenuItem>
          </Box>
        ))}
      </Menu>
    </Box>
  );
};

SolutionMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      lang: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onChangeLanguage: PropTypes.func,
  toggleClose: PropTypes.func,
  toggleOpen: PropTypes.func,
  toggle: PropTypes.object,
};

export default SolutionMenu;
